export var ROOM_3 = {
    option: "capitole_buache",
    max: 718,
};
export var ROOM_4 = {
    option: "capitole_schnegg",
    max: 136,
};
export var RENTAL_REQUEST_MINIMUM_DELAY = 30;
